module.exports = {
    property_top_up:'資產充值',
    main_net:'主網',
    wallet_address:'錢包地址（此地址只可接收USDT）',
    important_tip:'重要提示',
    least_top_up_money:'最少充值金額爲',
    top_up_tip1:'請仔細確認地址，充錯無法找回',
    top_up_tip2:'大約3~5分鐘到賬',
    confirm:'確定',
    get_tip:'獲取資產充值信息失敗 !',
    copy_success:'複製成功 !',
    arrival_accounts: '到賬賬戶',
    funding_accounts: '資金賬戶',
    recharge_amount: '充值金額',
    payment_method: '充值方式',
    go_to_recharge: '立即充值',
    confirm_recharge: '確認儲值',
    to_copy_address: '點選複製下方儲值地址'
}
